import script from "./PaletteColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./PaletteColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./PaletteColorPicker.vue?vue&type=style&index=0&id=a95186f8&lang=scss"

const __exports__ = script;

export default __exports__